const steps = [
  {
    number: '01',
    icon: 'ri-chat-3-line',
    title: 'Initial Discovery',
    description:
      'We start with a focused conversation to understand your goals, challenges, and vision. No sales pitch – just honest dialogue.',
  },
  {
    number: '02',
    icon: 'ri-file-list-3-line',
    title: 'Analysis & Proposal',
    description:
      'We analyze your requirements and deliver a clear proposal with scope, timeline, and investment – transparent from day one.',
  },
  {
    number: '03',
    icon: 'ri-tools-line',
    title: 'Agile Development',
    description:
      'We build in iterative sprints, keeping you involved and informed at every step. You see progress, not just promises.',
  },
  {
    number: '04',
    icon: 'ri-rocket-line',
    title: 'Launch & Support',
    description:
      'We deploy with confidence and stay by your side post-launch – monitoring, iterating, and growing with your product.',
  },
];

export default function ProcessSection() {
  return (
    <section className="bg-[#0C1220] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-5">
            <span className="w-6 h-px bg-[#3B82F6]"></span>
            <span className="text-[#3B82F6] text-xs font-semibold uppercase tracking-widest">
              How We Work
            </span>
            <span className="w-6 h-px bg-[#3B82F6]"></span>
          </div>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-white leading-tight text-balance">
            Our Process
          </h2>
          <p className="text-slate-400 mt-4 max-w-xl mx-auto leading-relaxed text-sm">
            A clear, transparent process that keeps you informed and in control throughout the project.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={step.number} className="relative">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-7 left-[calc(50%+20px)] right-[-50%] h-px bg-[#1A2740] z-0"></div>
              )}
              <div className="relative z-10 flex flex-col items-center text-center bg-[#0C1220] p-6">
                <div className="w-14 h-14 flex items-center justify-center bg-[#1E3A5F]/40 border border-[#3B82F6]/20 rounded-xl mb-4">
                  <i className={`${step.icon} text-[#3B82F6] text-xl`}></i>
                </div>
                <span className="text-[#3B82F6] text-xs font-bold uppercase tracking-widest mb-2">
                  Step {step.number}
                </span>
                <h3 className="font-semibold text-white text-sm mb-2 leading-snug">
                  {step.title}
                </h3>
                <p className="text-slate-400 text-xs leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
